const uiSchema = () => ({});

export default uiSchema;
